import { ExtendedTheme } from '@cibo/ui'
import {
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  useTheme,
} from '@mui/material'
import { uniq } from 'ramda'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { useMultiselectCheckboxContext } from './MultiselectCheckboxContext'
import { MultiselectMenuItem } from './MultiselectFieldInput'

export const ANSWER_FOR_ALL = 'answerForAll'

export const MultiselectChangeAllInput = ({ style }: { style: CSSProperties | undefined }) => {
  const {
    combinedAnswer: value = {},
    allDisabled,
    options,
    onChangeAll,
    allDetailsAreCibo,
    programEngagementFields,
    optionDisplayString,
    year,
    traitId,
  } = useMultiselectCheckboxContext()
  const theme = useTheme<ExtendedTheme>()
  const { t } = useTranslation('@cibo/programs/MultiselectCheckboxFieldTable')

  const disabled = options.length === 0 || allDisabled
  const immutable = !!programEngagementFields.data?.filter(
    field =>
      !!field.findDetail?.({
        traitId,
        year,
      })?.immutable
  ).length

  const allOptions = uniq(['none', ...options])
  const displayValue = options.map(option => value[option]?.value === 'checked' && option)
  const displayStrings = displayValue.filter(val => !!val) as string[]

  return (
    <FormControl sx={{ m: 1, width: 300 }} style={style}>
      <Select<string[]>
        labelId="all-practices-input-label"
        id="all-practices-input"
        data-testid="all-practices-input"
        multiple
        value={displayStrings || []}
        onChange={!allDisabled ? onChangeAll : (event: SelectChangeEvent<string[]>) => null}
        input={<OutlinedInput />}
        label={t('selectPractice')}
        renderValue={selected =>
          selected.length
            ? uniq(selected).map(optionDisplayString).join(', ')
            : value.none?.value === 'checked'
            ? optionDisplayString('none')
            : t('selectPractice')
        }
        disabled={immutable || disabled}
        displayEmpty
      >
        {Object.keys(value).map(answer =>
          value[answer].stale ? (
            <MenuItem
              style={{
                backgroundColor:
                  allDetailsAreCibo && value[answer]?.value !== 'unchecked'
                    ? theme.palette.ciboSensed
                    : undefined,
              }}
              key={answer}
              data-testid={`choice-${answer}`}
              value={answer}
            >
              <MultiselectMenuItem
                key={answer}
                typeValues={{ type: 'combined' }}
                stale={true}
                option={answer}
              />
            </MenuItem>
          ) : null
        )}
        {allOptions.map(option => (
          <MenuItem
            style={{
              backgroundColor:
                allDetailsAreCibo && value[option]?.value !== 'unchecked'
                  ? theme.palette.ciboSensed
                  : undefined,
            }}
            key={option}
            data-testid={`choice-${option}`}
            value={option}
          >
            <MultiselectMenuItem
              key={option}
              typeValues={{ type: 'combined' }}
              stale={false}
              option={option}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
